// contactUsThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import showToast from "../../utils/toastNotifications";

export const submitContactUs = createAsyncThunk(
  "contact/submitContactUs",
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await api.post("/contact-us/submit", contactData);

      if (response.status === 200) {
      //  showToast("success", "Inquiry submitted successfully!");
        return response.data;
      } else {
        showToast("error", "Failed to submit the inquiry.");
        return rejectWithValue("Failed to submit the inquiry.");
      }
    } catch (error) {
      showToast("error", error.message || "Failed to submit the inquiry.");
      return rejectWithValue(error.message);
    }
  }
);
